import useIsDesktop from '@/src/hooks/useIsDesktopLayout';

const MobileOnlyComponent = ({ children }) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? null : children;
};

export default MobileOnlyComponent;
